import dayjs from "dayjs";
import { RestaurantLeave } from "src/business/restaurant/leave";
import { RestaurantLeaveData } from "src/data/types/leave";

export const mapRestaurantLeaveDataToRestaurantLeave = (leaveData: RestaurantLeaveData): RestaurantLeave => ({
    id: leaveData.id,
    restaurantId: leaveData.restaurantId,
    date: dayjs(leaveData.date).format("YYYY-MM-DD"),
})